import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const OpenForm = ({ state }) => {
    const location = useLocation();
    const currentData = location.state;

    console.log(currentData, "currentData")

    const navigate = useNavigate();
    const { data } = useSelector(event => event.user);
    const openInNewTab = () => {

    }
    return (
        <div className='ess-page'>
            <div className='bordered-wrapper'>
                <h1 className='ml-1 grid mb-0'>
                    <div className='col-fixed' style={{ width: '25px' }}>
                        <div className='mt-2'><i className='pi pi-arrow-circle-left link' onClick={() => navigate('/training')} /></div>
                    </div>
                    <div className='col'>
                        <div className='mt-2'>{data?.desc}</div>
                    </div>
                    <div className='col-fixed'>
                        <div className='mt-2 mr-2'><i className='pi pi-window-maximize link' onClick={openInNewTab} /></div>
                    </div>
                </h1>
                <iframe width="100%" height="480px"
                    frameborder="0" marginwidth="0" marginheight="0"
                    style={{ border: 'none', maxWidth: '100%', maxHeight: '100vh', height: 'calc(100vh - 189px)', background: '#fff' }}
                    // allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen
                    src={currentData}
                >
                    Not working
                </iframe>
            </div>
        </div>
    )
}

export default OpenForm